module.exports = __webpack_public_path__ + "img/mercedes.d56c3138.svg";